import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { ValueDateField } from '@/components/forms/RunRiskCalibrationForm/fields/ValueDateField'

export interface VolDivAdjustmentsFieldsProps {}

export const VolDivAdjustmentsFields: React.FC<VolDivAdjustmentsFieldsProps> = ({}) => {
  return (
    <FormFieldRow>
      <ValueDateField />
    </FormFieldRow>
  )
}
